
(() => {
  const translations = {
    "Buy 1": "Koop 1",
    "Buy 2": "Koop 2",
    "Buy 3": "Koop 3"
  };

  let translating = false;

  function translateBundles() {
    if (translating) return;
    translating = true;

    try {
      document.querySelectorAll(
        '.sleekbundles-widget .sb-rlabel'
      ).forEach(element => {
        const current = element.textContent.trim();
        const translated = translations[current];

        if (translated && current !== translated) {
          element.textContent = translated;
        }
      });
      // Badges vertalen
document.querySelectorAll(
  '.sleekbundles-widget'
).forEach(widget => {
  const walker = document.createTreeWalker(
    widget,
    NodeFilter.SHOW_TEXT
  );

  const replacements = [];
  let node;

  while ((node = walker.nextNode())) {
    const original = node.textContent;
    const translated = original
      .replace(/\bBEST VALUE\b/gi, 'BESTE DEAL')
      .replace(/\bPOPULAR\b/gi, 'MEEST GEKOZEN')
      .replace(/Choose a kleur & maat/gi, 'Kies kleur en maat');

    if (translated !== original) {
      replacements.push([node, translated]);
    }
  }

  replacements.forEach(([node, value]) => {
    node.textContent = value;
  });
});
    } finally {
      translating = false;
    }
  }

  function init() {
    translateBundles();

    const observer = new MutationObserver(() => {
      translateBundles();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
